import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { FolderPlus, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { studioError } from "@/lib/studio";

export const SaveVideoToLibrary = ({ outputId, saved = false, testId = `save-video-library-${outputId}` }) => {
  const qc = useQueryClient(), [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      await api.post(`/creative/library/outputs/${outputId}`);
      await Promise.all([qc.invalidateQueries({ queryKey: ["media-library"] }), qc.invalidateQueries({ queryKey: ["studio-finished-videos"] })]);
      toast.success("Saved to My library. Your original video is unchanged.");
    } catch (e) { toast.error(studioError(e)); } finally { setBusy(false); }
  };
  return <button type="button" className="secondary-btn" disabled={busy || saved} onClick={save} data-testid={testId}>
    {busy ? <Loader2 size={15} className="sw-spin"/> : saved ? <Check size={15}/> : <FolderPlus size={15}/>}{saved ? "In My library" : busy ? "Saving…" : "Save to My library"}
  </button>;
};
